export enum RoomStateVideoMethod {
  broadcast = 'broadcast',
  streaming = 'streaming',
}
